import { PartType } from '../enums/part-type-enum';
import { prop, required, compose } from '@rxweb/reactive-form-validators';
import { Validators } from '@angular/forms';
import { CustomValidators } from '../../extensions/custom-validators';
export class Part {
  constructor() {}

  @prop()
  partType?: PartType;

  @prop()
  @compose({ validators: [ Validators.required, CustomValidators.isValidCNPJ ] })
  socialNumber?: string;

  @prop()
  @required()
  businessName?: string;

  @prop()
  @required()
  establishmentDate?: string;

  @prop()
  mainActivity?: string;
}
